import useDarkMode from '@hooks/useDarkMode';
import './index.scss'

import React, { useEffect, useRef, useState } from "react";
import icon from 'url:@assets/icons/options-icon.svg'

export type DropdownItem = {
  title: string;
  icon: DropdownItemIcon;
  onClick: () => void;
}

export enum DropdownItemIcon {
  DOCUMENT,
  SHARE,
  MAIL
}

export type DropdownProps = {
  title?: string;
  items: DropdownItem[]
}

const iconComponent = (icon: DropdownItemIcon) => {
  const fill = "#F58B8B";

  switch (icon) {
    case DropdownItemIcon.DOCUMENT:
      return <svg width="66" height="83" viewBox="0 0 66 83" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.7246 52.6367C16.0156 52.6367 14.7949 51.416 14.7949 49.8535C14.7949 48.2422 16.0156 47.0215 17.7246 47.0215H47.3633C49.0235 47.0215 50.293 48.2422 50.293 49.8535C50.293 51.416 49.0235 52.6367 47.3633 52.6367H17.7246ZM17.7246 67.334C16.0156 67.334 14.7949 66.1133 14.7949 64.5019C14.7949 62.9394 16.0156 61.6699 17.7246 61.6699H47.3633C49.0235 61.6699 50.293 62.9394 50.293 64.5019C50.293 66.1133 49.0235 67.334 47.3633 67.334H17.7246ZM12.2559 82.3242H52.7344C60.9375 82.3242 65.0391 78.1738 65.0391 69.873V35.9863H37.1094C31.9336 35.9863 29.4922 33.5449 29.4922 28.3691V0H12.2559C4.05278 0 0 4.1504 0 12.4512V69.873C0 78.2226 4.05278 82.3242 12.2559 82.3242ZM37.1094 30.2734H64.5996C64.3555 28.4668 63.1348 26.7578 61.084 24.6582L40.8203 3.9551C38.8184 1.9043 37.0117 0.634797 35.2051 0.341797V28.3691C35.2051 29.6387 35.8887 30.2734 37.1094 30.2734Z" fill={fill} />
      </svg>
    case DropdownItemIcon.MAIL:
      return <svg width="94" height="67" viewBox="0 0 94 67" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M46.5332 37.207C47.7539 37.207 48.9746 36.7188 50.0977 35.6934L88.5742 1.9531C86.377 0.585902 83.9844 0 80.6641 0H12.4512C9.13088 0 6.73828 0.585902 4.49218 1.9531L43.0176 35.6934C44.1406 36.7188 45.3614 37.207 46.5332 37.207ZM0.83008 59.9121L28.9551 31.7871L0.73238 7.0801C0.43948 7.7149 0 9.5703 0 12.2559V54.4434C0 56.8359 0.34178 58.5449 0.83008 59.9121ZM11.084 66.6992H82.0313C84.7656 66.6992 86.9629 66.0645 88.4278 65.0879L59.2774 35.9863L53.8574 40.8203C51.5625 42.8223 49.0235 43.8477 46.5332 43.8477C44.0918 43.8477 41.5528 42.8223 39.2578 40.8203L33.7891 35.9863L4.63868 65.0879C6.10348 66.0645 8.34958 66.6992 11.084 66.6992ZM92.2854 59.9121C92.7244 58.5449 93.1154 56.8359 93.1154 54.4434V12.2559C93.1154 9.5703 92.6754 7.7149 92.3824 7.0801L64.1602 31.7871L92.2854 59.9121Z" fill={fill} />
      </svg>
    case DropdownItemIcon.SHARE:
      return <svg width="88" height="111" viewBox="0 0 88 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.839 110.248H71.8423C82.0744 110.248 87.1603 105.141 87.1603 95.085V46.4341C87.1603 36.3679 82.0744 31.2714 71.8423 31.2714H58.2569V39.1661H71.7177C76.5001 39.1661 79.3068 41.7859 79.3068 46.8175V94.7016C79.3068 99.7849 76.5001 102.342 71.7177 102.342H15.9636C11.0873 102.342 8.3745 99.7849 8.3745 94.7016V46.8175C8.3745 41.7859 11.0873 39.1661 15.9636 39.1661H29.4455V31.2714H15.839C5.6587 31.2714 0.520996 36.3468 0.520996 46.4341V95.085C0.520996 105.162 5.6587 110.248 15.839 110.248ZM43.8148 72.0197C45.9387 72.0197 47.7415 70.2686 47.7415 68.1965V18.1006L47.4204 10.7612L50.6914 14.2497L58.0936 22.1177C58.8086 22.8844 59.8034 23.2783 60.736 23.2783C62.7871 23.2783 64.3311 21.8378 64.3311 19.8797C64.3311 18.7919 63.896 18.0357 63.1292 17.3207L46.6431 1.3933C45.6694 0.419495 44.8509 0.0878906 43.8148 0.0878906C42.8305 0.0878906 42.0014 0.419495 40.9864 1.3933L24.4898 17.3207C23.7748 18.0357 23.3396 18.7919 23.3396 19.8797C23.3396 21.8378 24.8214 23.2783 26.883 23.2783C27.8156 23.2783 28.8622 22.8844 29.5666 22.1177L36.9794 14.2497L40.2609 10.7506L39.9398 18.1006V68.1965C39.9398 70.2686 41.7426 72.0197 43.8148 72.0197Z"
          fill={fill} />
      </svg>
  };
}

export default function Dropdown(props: DropdownProps) {
  const menuRef = useRef<HTMLDivElement>(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return <div className="menu" ref={menuRef}>
    <button onClick={(e) => {
      e.stopPropagation();
      setDropdownVisible(!isDropdownVisible);
    }}>
      <img src={icon} alt="Menu" />
    </button>
    {isDropdownVisible && <div className="dropdown-menu">
      {props.title && <p className='title'>{props.title}</p>}
      <ul>
        {props.items.map((item, idx) => {
          const icon = iconComponent(item.icon);

          return <React.Fragment key={item.title}>
            {idx !== 0 ? <div className='divider' /> : null}
            <li
              onClick={(e) => {
                e.preventDefault();
                item.onClick();

                setDropdownVisible(false);
              }}
            >
              {icon}
              <span>{item.title}</span>
            </li>
          </React.Fragment>
        })}
      </ul>
    </div>}
  </div>
}